import i18next from 'i18next';
import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';
import cn from 'classnames';

import { ReactComponent as Arrow } from '~assets/arrow-down.svg';
import { selectOptionPropTypes } from '~propTypes/select';

import Options from './Options';
import SearchInput from './SearchInput';
import styles from './styles.module.scss';
import { useSearcher } from './useSearcher';

const SearchSelect = ({
  options,
  className,
  title,
  showArrow,
  placeholder,
  onSelect,
  defaultValue,
  searcherClassName
}) => {
  const {
    selected,
    filteredOptions,
    handleOpen,
    handleInput,
    open,
    handleSelect,
    deleteSelected
  } = useSearcher({
    options,
    onSelect,
    defaultValue
  });

  return (
    <div>
      <div className="row space-between middle p-right-5">
        <div className={styles.title}>{title}</div>
        {selected && (
          <div className={styles.deleteButton} onClick={deleteSelected}>
            {i18next.t('AddressElement:delete')}
          </div>
        )}
      </div>
      <div
        onClick={handleOpen}
        className={cn(className, {
          [styles.containerSelected]: open,
          [styles.container]: !open
        })}>
        <div
          className={cn('row space-between', {
            [styles.selected]: selected,
            [styles.placeholder]: !selected
          })}>
          {selected ? selected.label : placeholder}
          {showArrow && <Arrow className={open && styles.rotate} />}
        </div>
      </div>
      {open && (
        <div className={styles.optionsContainer}>
          <SearchInput handleInput={handleInput} searcherClassName={searcherClassName} />
          <Options filteredOptions={filteredOptions} handleSelect={handleSelect} />
        </div>
      )}
    </div>
  );
};

SearchSelect.propTypes = {
  options: arrayOf(selectOptionPropTypes).isRequired,
  className: string,
  defaultValue: string,
  placeholder: string,
  searcherClassName: string,
  showArrow: bool,
  title: string,
  onSelect: func
};

export default SearchSelect;
